export default "__VITE_ASSET__55554820__"